import React from "react";

import { backendItems, items, softSkills } from "./constants/skillsList";

function Skills() {
  return (
    <section
      className="skills_section my-10 pb-[50px] text-center overflow-x-hidden"
      id="about"
    >
      <h2 className="text-[48px] max-sm:text-[35px] font-bold text-yellow mb-14">
        Skills
      </h2>
      <article className="bg-yellow border border-black w-[fit-content] relative  mt-5">
        <h4 className="absolute text-gray-700 bottom-0 text-[30px] opacity-[0.6]">
          Front End
        </h4>
        <ul className="animation-item flex justify-between items-center">
          {items.map((item, index) => (
            <li
              key={index}
              className={`outlined-text-mini w-[200px] text-4xl font-bold p-4 text-white`}
            >
              {item}
            </li>
          ))}
        </ul>
      </article>
      <article className="bg-yellow border border-black w-[fit-content] relative  mt-5">
        <h4 className="absolute text-gray-700 bottom-0 text-[30px] opacity-[0.6]">
          Back End
        </h4>
        <ul className="animation-item flex justify-between items-center">
          {backendItems.map((item, index) => (
            <li
              key={index}
              className={`outlined-text-mini w-[300px] text-4xl font-bold text-[35px] p-4 text-white`}
            >
              {item}
            </li>
          ))}
        </ul>
      </article>
      <article className="bg-[transparent] border-y border-black relative w-[fit-content]  mt-5">
        <h4 className="absolute text-gray-700 bottom-0 text-[30px] opacity-[0.6]">
          Soft Skills
        </h4>
        <ul className="animation-item flex justify-between items-center">
          {softSkills.map((item, index) => (
            <li
              key={index}
              className={`outlined-text-mini w-[300px] text-4xl font-bold text-[30px]`}
            >
              {item}
            </li>
          ))}
        </ul>
      </article>
    </section>
  );
}

export default Skills;
